import React from 'react';
import pastor from '../Assets/pastor.jpg'

const WelcomeSection = () => {
  return (
    <div className='welcome-wrapper'>
            <section className="welcome-section">
                <div className="welcome-overlay">
                  <div className="welcome-content">
                    <h1 className="welcome-title">You Belong Here</h1>
                    <p className="welcome-text">
                      At RCCG David's Court, we believe every life carries divine significance. Whether you're exploring faith or seeking deeper spiritual roots, our arms are open wide. We are a Christ-centered family devoted to grace, truth, and transformation.
                    </p>
                    <p className="welcome-text">
                      Here, you will find a place to grow, serve, and shine. Through worship, fellowship, and outreach, we journey together—becoming vessels of light in our city and beyond. You are not just welcome; you belong here.
                    </p>
                    <a href="/about" className="welcome-button">Explore Our Mission</a>
                  </div>

                  <div className="pastor-section">
                    <img src={pastor} alt="Pastor Sabbath Akhabue" className="pastor-image" />
                    <div className="pastor-info">
                      <h3>Sabbath Akhabue</h3>
                      <p>Lead Pastor</p>
                    </div>
                  </div>
                </div>
            </section>
          </div>
  );
};

export default WelcomeSection;
